/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespFeaturedModule_homepage = {
    readonly featuredModule: {
        readonly primaryItem?: {
            readonly cta: string | null;
            readonly imageUrl: string | null;
            readonly title: string | null;
            readonly linkData: {
                readonly path: string | null;
                readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
            };
        } | null;
        readonly items?: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly cta: string | null;
            readonly imageUrl: string | null;
            readonly title: string | null;
            readonly linkData: {
                readonly path: string | null;
                readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
            };
        } | null> | null;
    } | null;
    readonly " $refType": "HpRespFeaturedModule_homepage";
};
export type HpRespFeaturedModule_homepage$data = HpRespFeaturedModule_homepage;
export type HpRespFeaturedModule_homepage$key = {
    readonly " $data"?: HpRespFeaturedModule_homepage$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespFeaturedModule_homepage">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cta",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "imageUrl",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "linkData",
  "storageKey": null,
  "args": null,
  "concreteType": "LinkData",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SeoLink_linkData",
      "args": null
    }
  ]
};
return {
  "kind": "Fragment",
  "name": "HpRespFeaturedModule_homepage",
  "type": "Homepage",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "featuredModule",
      "name": "module",
      "storageKey": "module(type:\"featured\")",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "featured"
        }
      ],
      "concreteType": null,
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "FeaturedModule",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "primaryItem",
              "storageKey": null,
              "args": null,
              "concreteType": "FeaturedItem",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/)
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": "FeaturedItem",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "cmsId",
                  "args": null,
                  "storageKey": null
                },
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '7e62bd15798417e111a536a62b419263';
export default node;
